
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.957 7.626C4.01 8.562 5.647 9.5 8 9.5s3.99-.938 5.043-1.874c.528-.47.91-.94 1.158-1.29a6.028 6.028 0 00.35-.555l.002-.005L15 6l.447.224-.001.002-.002.004-.007.012a2.716 2.716 0 01-.102.184c-.071.12-.176.288-.318.488A8.697 8.697 0 0113.6 8.467l1.3 1.733-.8.6-1.295-1.726c-.679.457-1.5.865-2.473 1.127l.647 2.155-.958.288-.672-2.24a9.304 9.304 0 01-1.35.096c-.474 0-.923-.034-1.348-.097l-.672 2.24-.958-.287.646-2.155a8.232 8.232 0 01-2.473-1.127L1.9 10.8l-.8-.6 1.3-1.733A8.693 8.693 0 01.982 6.914a7.007 7.007 0 01-.421-.672L.556 6.23l-.002-.004-.001-.001v-.001L1 6l.447-.224.002.005a1.802 1.802 0 00.077.137c.058.098.148.243.272.418.249.35.63.82 1.159 1.29z","fill":"currentColor"}})])
          )
        }
      }
    